<template>
  <UFormField
    v-bind="{ ...forwardedProps, ...$attrs }"
    :error="fieldError"
    class="p-form-field group/p-form-field"
    :data-sr-only="srOnly || undefined"
    :data-hide-label-spacing="
      (srOnly && !hint && !slots.hint && !description && !slots.description) || undefined
    "
  >
    <template v-if="slots.label" #label="slotProps"
      ><slot name="label" v-bind="slotProps"
    /></template>
    <template v-if="slots.hint" #hint="slotProps"><slot name="hint" v-bind="slotProps" /></template>
    <template v-if="slots.description" #description="slotProps"
      ><slot name="description" v-bind="slotProps"
    /></template>
    <template v-if="slots.help" #help="slotProps"><slot name="help" v-bind="slotProps" /></template>
    <template v-if="slots.error" #error="slotProps"
      ><slot name="error" v-bind="slotProps"
    /></template>
    <template v-if="slots.default" #default="slotProps"><slot v-bind="slotProps" /></template>
  </UFormField>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { reactiveOmit } from "@vueuse/core"
import UFormField, {
  type FormFieldProps,
  type FormFieldSlots
} from "@nuxt/ui/components/FormField.vue"

interface Props extends FormFieldProps {
  /** Visually hide the label while keeping it accessible to screen readers. */
  srOnly?: boolean
  /** Regle error messages; the standard error prop takes precedence, including false. */
  errors?: string[]
}
const props = withDefaults(defineProps<Props>(), {
  size: "md",
  orientation: "vertical",
  error: undefined
})
const slots = defineSlots<FormFieldSlots>()
const forwardedProps = reactiveOmit(props, "errors", "srOnly")
const fieldError = computed(() => props.error ?? props.errors?.[0])
defineOptions({ inheritAttrs: false })
</script>
